// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-b4ufO04_"};